var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.question.choices),function(choice,index){return _c('div',{key:index,staticClass:"md-layout-item md-size-100"},[_c('md-checkbox',{attrs:{"value":choice,"disabled":_vm.readOnly}},[_vm._v(" "+_vm._s(choice)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }